import { useState } from "react";

import ProjectsMobileItem from "./ProjectsMobileItem";
import Arrow from "../LogoSVG/Arrow";
import { title } from "process";

import thumbnailNFTMarket from "../../public/thumbnail-nftmarket.png";
import netcompanyLogo from "../../public/netcompany.png";
import thumbnailThesis from "../../public/thumbnail-thesis.png";
import thumbnailDiffusion from "../../public/thumbnail-diffusion.png";
import thumbnailAIC from "../../public/thumbnail-aic24.png";
import thumbnail2D3D from "../../public/thumbnail-2d-3d.png";
import thumbnailPorfolio from "../../public/thumbnailPortfolio.png";
import thumbnaulCommitVuln from "../../public/mockup.png";

function ProjectsMobile() {
  const [hoveredIndex, setHoveredIndex] = useState<number>();

  return (
    <section id="projects" className="pt-[95px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-8">PINNED PROJECTS</p>
        </div>

        <ProjectsMobileItem
          title="An Intelligent Digital Diary"
          description="A smart app to transform traditional journaling through innovative functionalities."
          highLight
          thumbnail={thumbnailThesis}
          url="/projects/thesis"
        />

        <ProjectsMobileItem
          title="GitHub Commit Vulnerability Prediction"
          description="An end-to-end ML pipeline for predicting insecure code files in GitHub commits."
          thumbnail={thumbnaulCommitVuln}
          url="/projects/commit-vulnerability-predictor"
        />

        <ProjectsMobileItem
          title="NFT Marketplace"
          description="Led a team in a Software Engineering course to build a trading NFT platform on the Ethereum."
          thumbnail={thumbnailNFTMarket}
          url="https://github.com/lnqminh3003/AuraSky_NFT-Market"
        />

        <ProjectsMobileItem
          title="Event Querying from Videos"
          description="A system for querying specific frames within a 1,400-video dataset using text inputs."
          thumbnail={thumbnailAIC}
          url="https://github.com/lnqminh3003/aic24"
        />

        {/* <ProjectsMobileItem
          title="Stable Diffusion Web Application"
          description="AI-generated image website with Replicate, Web3 API, and Firebase Storage."
          url="https://github.com/lnqminh3003/CS422-AI-DiffusionWeb"
          listTech={[
            "JavaScript",
            "JavaScript",
            "JavaScript",
            "JavaScript",
            "JavaScript",
          ]}
          thumbnail={thumbnailDiffusion}
        /> */}

        <ProjectsMobileItem
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
          thumbnail={thumbnail2D3D}
          title="From 2D Image to 3D Model"
          description="A script using Python and Blender API to convert 2D nature images, like mountains and landscapes, into 3D models."
          url="https://github.com/lnqminh3003/transform-2D-image-to-3D-model"
          index={5}
        />

        {/* <ProjectsMobileItem
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
          thumbnail={thumbnailPorfolio}
          title="Personal Portfolio Website"
          description="A responsive portfolio site built with React.js and Tailwind CSS."
          url="https://minh-le.vercel.app/"
          index={6}
          listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
        /> */}
      </div>
    </section>
  );
}

export default ProjectsMobile;
